// eslint-disable-next-line import/no-unresolved
import { produce } from 'immer';

export default {
  3: state => {
    const newState = produce(state, draft => {
      draft.user = draft.user || {};
      if (state.isPasswordSubmitted) {
        draft.user.isPasswordSubmitted = state.isPasswordSubmitted;
        delete draft.isPasswordSubmitted;
      }
    });

    return newState;
  },
};
